

















import { Component, mixins } from '@niknevis/vue-modules'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { Prop } from 'vue-property-decorator'
import TesList from '@/modules/shared/components/shared/TesList.vue'

@Component({
  components: {
    TesList,
    Modal
  }
})
export default class InfoDialog extends mixins<DialogMixin>(DialogMixin) {
  @Prop({ default: 'اطلاعات آیتم' }) header: string
  @Prop({ default: () => ({}) }) innerCardProps: object
  @Prop({ required: true }) items: TesList['items']

  private dialogVisibility = false
}
